import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import ProjectOverview from '../../../../components/Projects/ProjectOverview';

/**
 * Overview tab — Current / Past / Future layouts share this route.
 */
const ProjectOverviewTab = () => {
  const { project, registerTabRefresh, reloadProject } = useOutletContext();

  useEffect(() => {
    if (typeof registerTabRefresh !== 'function') return undefined;
    return registerTabRefresh(reloadProject);
  }, [registerTabRefresh, reloadProject]);

  return <ProjectOverview project={project} />;
};

export default ProjectOverviewTab;
